<mat-progress-bar mode="indeterminate" *ngIf="requests$ | async | hasAny"></mat-progress-bar>

<fl-blank-layout-container *ngIf="notFound$ | async">
  <fl-four-oh-four></fl-four-oh-four>
</fl-blank-layout-container>

<router-outlet *ngIf="notFound$ | async | none"></router-outlet>
